import { useEffect, useRef } from 'react';

import {
  useEventState,
  useEventActions,
} from './EventContext';

import { getEvent } from './restApi';

const EventLoader = () => {
  const state = useEventState();
  const { onResponse, onError } = useEventActions();
  const loadedEventIdRef = useRef(null);

  useEffect(() => {
    if (state?.event?.id && loadedEventIdRef.current !== state.event.id) {
      loadedEventIdRef.current = state.event.id;
      getEvent({
        id: state.event.id,
        onResponse,
        onError,
      });
    }
  }, [state?.event?.id]);

  return null;
};

export default EventLoader;
